import { lazy } from "react";

const HomePage = lazy(() => import("../pages/Home/UI/Home.view"));
// Profile
const ProfilePage = lazy(() => import("../pages/Profile/UI/AdminProfile.view"));
const UserProfilePage = lazy(() =>
  import("../pages/Profile/UI/UserProfile.view")
);
// Users
const PreviewPage = lazy(() =>
  import("../pages/UserPreview/UI/UserPreview.view")
);
const CaregiverPreviewPage = lazy(() =>
  import("../pages/CaregiverPreview/UI/CaregiverPreviewView.jsx")
);
const UsersV2 = lazy(() => import("../pages/Users/UI/Users.view"));
const UsersPage = lazy(()=> import("../pages/Users/UI/userV2.view"));
const CaregiversPage = lazy(() =>
  import("../pages/Caregivers/UI/Caregivers.view")
);
const CaregiversV2Page = lazy(() =>
  import("../pages/Caregivers/UI/CaregiversV2.view")
);
const CareHomesPage = lazy(() =>
  import("../pages/Carehomes/UI/Carehomes.view")
);
const CareHomesV2Page = lazy(() =>
  import("../pages/Carehomes/UI/CarehomesV2.view")
);

// Circles
const CareCirclesPage = lazy(() =>
  import("../pages/CareCircles/UI/CareCircles.view")
);
const SocialCirclesPage = lazy(() =>
  import("../pages/SocialCircles/UI/SocialCircles.view")
);
const ArchivedCirclesPage = lazy(()=>
  import("../pages/SocialCircles/UI/ArchivedSocialCircles.view"))
const SkillCirclesPage = lazy(() =>
  import("../pages/SkillCircles/UI/SkillCircles.view")
);
const CreateCareCircleChatPage = lazy(()=>
  import("../pages/CareCircles/UI/Components/CreateCareCircleChat")
);
const CreateCargiverChatPage = lazy(()=>
  import("../pages/CareCircles/UI/Components/AddMembersChat")
)
const CreateCarehomeChatPage = lazy(() =>
  import("../pages/Carehomes/UI/components/CreateCarehomeChat")
);
// Learning Journeys
const LJPage = lazy(() =>
  import("../pages/LearningJourneys/UI/LearningJourneys.view")
);
const CreateLJPage = lazy(() =>
  import("../pages/LearningJourneys/UI/LJ/AddLJ.view")
);
const EditLJPage = lazy(() =>
  import("../pages/LearningJourneys/UI/LJ/EditLJ.view")
);
const StepsPage = lazy(() =>
  import("../pages/LearningJourneys/UI/Steps/Steps.view")
);
const EditStepPage = lazy(() =>
  import("../pages/LearningJourneys/UI/Steps/EditStep.view")
);

// Content space
const DataContentPage = lazy(() =>
  import("../pages/ContentSpace/UI/ContentSpace.view")
);
const CreateContentPage = lazy(() =>
  import("../pages/ContentSpace/UI/AddContent.view")
);
const EditContentPage = lazy(() =>
  import("../pages/ContentSpace/UI/EditContent.view")
);

// Resources
const ResourcesPage = lazy(() =>
  import("../pages/Resources/UI/Resources.view")
);
const ResourcesDiscoverPage = lazy(() =>
  import("../pages/Resources/UI/ResourcesDiscover.view")
);
const CreateResourcePage = lazy(() =>
  import("../pages/Resources/UI/CreateResource.view")
);
const EditResourcePage = lazy(() =>
  import("../pages/Resources/UI/EditResource.view")
);

// Trust Sources
const TrustSourcesPage = lazy(() =>
  import("../pages/TrustSources/UI/TrustSources.view")
);

// Sub-Admins
const SubAdminsPage = lazy(() =>
  import("../pages/SubAdmins/UI/SubAdmins.view")
);

// care facility 
const CareFacilityPage = lazy(() =>
  import("../pages/CareFacility/UI/Carefacility.view")
);
const CreateCareFacilityPage = lazy(() =>
  import("../pages/CareFacility/UI/CreateCareFacility.view")
);
const CareFacilityDetailPage = lazy(() =>
  import("../pages/CareFacility/UI/CareFacilityDetail.view")
);
// global events
const GlobalEventsPage = lazy(() =>
  import("../pages/GlobalEvent/UI/GlobalEventView")
);

const CreateGlobalEventPage = lazy(() =>
  import("../pages/GlobalEvent/UI/CreateGlobalEventView")
);

const EditGlobalEventPage = lazy(() =>
  import("../pages/GlobalEvent/UI/EditGlobalEventView")
);

const GlobalEventDetailPage = lazy(() =>
  import("../pages/GlobalEvent/UI/GlobalEventDetail")
);
// social circle event  
const SocialCircleEventsPage = lazy(() =>
  import("../pages/SocialCircleEvent/UI/SocialCircleEvent.view")
);
const CreateSocialCircleEventsPage = lazy(() =>
  import("../pages/SocialCircleEvent/UI/CreateSocialCircleEvent.view")
);
const SocialCircleEventsDetailPage = lazy(() =>
  import("../pages/SocialCircleEvent/UI/SocialCircleEventDetail.view")
);

// const CreateResourcePage = lazy(() =>
//   import("../pages/Resources/UI/CreateResource.view")
// );
// const EditResourcePage = lazy(() =>
//   import("../pages/Resources/UI/EditResource.view")
// );


// Zinnia Resources
const ZinniaPage = lazy(() =>
  import("../pages/ZinniaResources/UI/Zinnia.view")
);
const CreateZinniaPage = lazy(() =>
  import("../pages/ZinniaResources/UI/CreateZinnia.view")
);
const EditZinniaPage = lazy(() =>
  import("../pages/ZinniaResources/UI/EditZinnia.view")
);

// Dashboards
const DashboardThriversPage = lazy(() =>
  import("../pages/Dashboards/views/AnalyticsPerThriver.view")
);
const DashboardSummary = lazy(() =>
  import("../pages/DashboardSummary/UI/DashboardSummary.view")
);
const DashboardMonthlyHealthCheckAnalytics = lazy(() =>
  import("../pages/Dashboards/views/HealthAnalyticsChartDetails.view")
);
const DashboardCaregiverPage = lazy(() =>
  import("../pages/Dashboards/Caregivers/CaregiversAnalytics.view")
);
const DashboardMoodPage = lazy(() =>
  import("../pages/Dashboards/views/Mood.view")
);
const DashboardEngagementPage = lazy(() =>
  import("../pages/Dashboards/views/Engagement.view")
);
const DashboardHealthCheckPage = lazy(() =>
  import("../pages/Dashboards/views/HealthCheck.view")
);
const DashboardHealthDetailPage = lazy(() =>
  import("../pages/Dashboards/views/HealthDetails.view")
);
const DashboardSmartWatchPage = lazy(() =>
  import("../pages/Dashboards/views/SmartWatch.view")
);
const DashboardSmartWatchGraphPage = lazy(() =>
  import("../pages/Dashboards/views/SmartWatchGraph.view")
);
const ThrivingAIAnalyticsPage = lazy(() =>
  import("../pages/Dashboards/ThrivingAI/ThrivingAI.view")
);

const DashboardActivityLogPage = lazy(() =>
  import("../pages/Dashboards/views/ActivityLog.view")
);
const DashboardDailyAnalyticsPage = lazy(() =>
  import("../pages/Dashboards/views/DailyAnalytics.view")
);
const DashboardSensorActivityInsightsPage = lazy(() =>
  import("../pages/Dashboards/SensorActivityInsights/SensorActivityInsights")
);
const DashboardRoomOccupancyPage = lazy(() =>
  import("../pages/Dashboards/SensorActivityInsights/RoomOccupancyPage")
);

const DashboardActivityLogDetailsPage = lazy(() =>
  import("../pages/Dashboards/views/ActivityLogDetails.view")
);
const DashboardGameUserDetailsPage = lazy(()=>
import("../pages/Dashboards/BrainBoost/UI/UserGameDetails"))

const ChatnelsMoodPage = lazy(() =>
  import("../pages/Dashboards/views/ChatnelsMood.view")
);

const ChatnelsDetailPage = lazy(() =>
  import("../pages/Dashboards/views/ChatnelsDetails.view")
);
const DashboardBrainBoostPage = lazy(() =>
  import("../pages/Dashboards/views/BrainBoostActivities.view")
);
const CareHomePermissions = lazy(()=>
  import("../pages/Permissions/CareHomePermissions"))

// Calendar
const CalendarPage = lazy(() => import("../pages/Calendar/UI/Calendar.view"));
const CalendarCreatePage = lazy(() =>
  import("../pages/Calendar/UI/CreateEvent.view")
);
const CalendarEditPage = lazy(() =>
  import("../pages/Calendar/views/EditEvent.view")
);
const CalendarEventsPage = lazy(() =>
  import("../pages/Calendar/UI/Events.view")
);

// Records
const RecordsPage = lazy(() => import("../pages/Records/UI/Records.view"));

// Internet of Things
const IoTPage = lazy(() => import("../pages/IoT/UI/IoT.view"));
const IoTLinkPage = lazy(() => import("../pages/IoT/UI/LinkDevice.view"));
const IoTEditPage = lazy(() => import("../pages/IoT/UI/EditDevice.view"));
const IoTLocationsPage = lazy(() => import("../pages/IoT/UI/Locations.view"));

// Reports
const ReportsPage = lazy(() => import("../pages/Reports/UI/Reports.view"));
const SocialCircleFlagPage=lazy(()=> import("../pages/SocialCircles/UI/components/SocialCircleFlag"))
// Version control
const VersionControlPage = lazy(() =>
  import("../pages/VersionControl/UI/VersionControl.view")
);
// Reports
const CustomerJourneyPage = lazy(() =>
  import("../pages/CustomerJourney/UI/CustomerJourney.view")
);
// Guides
const GuidesPage = lazy(() => import("../pages/Guides/UI/Guides.view"));
// Care plan
const CarePlanPage = lazy(() => import("../pages/CarePlan/UI/CarePlan.view"));

// Stress Index
const DashboardStressIndexPage = lazy(() =>
  import("../pages/Dashboards/views/StressIndex.view")
);
const DashboardStressUserScorePage = lazy(() =>
  import("../pages/Dashboards/StressIndex/StressUserScore")
);
const SupportListingPage = lazy(() =>
  import("../pages/Support/UI/Support.view")
);

// thriver survey
const LonelinessSurveyPage = lazy(() =>
  import("../pages/ThriversSurvey/views/Loneliness.view")
);

const WellbeingSurveyPage = lazy(() =>
  import("../pages/ThriversSurvey/views/WellBeing.view")
);

const PHQ9SurveyPage = lazy(() =>
  import("../pages/ThriversSurvey/views/PHQ9.view")
);

const GAD7SurveyPage = lazy(() =>
  import("../pages/ThriversSurvey/views/GAD7.view")
);
const EQ5SurveyPage = lazy(() =>
  import("../pages/ThriversSurvey/views/EQ5.view")
);
const SurveyUserDetailPage = lazy(() =>
  import("../pages/ThriversSurvey/views/SurveyUserDetails.view")
);

// sensors
const SensorPage = lazy(() =>
  import("../pages/Sensor/UI/Sensor.view")
);
//subAdmin
const AssignCareHomesPage = lazy(()=>
  import("../pages/SubAdmins/UI/AssignCareHomesPage")
);
const MyCareHomesPage = lazy(()=>
  import("../pages/SubAdmins/UI/MyCareHomesPage")
)


export {
  HomePage,
  ProfilePage,
  PreviewPage,
  CaregiverPreviewPage,
  UserProfilePage,
  UsersPage,
  UsersV2,
  CaregiversPage,
  CareHomesPage,
  CareCirclesPage,
  SocialCirclesPage,
  ArchivedCirclesPage,
  SkillCirclesPage,
  LJPage,
  CreateLJPage,
  EditLJPage,
  StepsPage,
  EditStepPage,
  DataContentPage,
  CreateContentPage,
  EditContentPage,
  ResourcesPage,
  ResourcesDiscoverPage,
  CreateResourcePage,
  EditResourcePage,
  TrustSourcesPage,
  SubAdminsPage,
  DashboardThriversPage,
  DashboardMonthlyHealthCheckAnalytics,
  DashboardCaregiverPage,
  DashboardMoodPage,
  DashboardEngagementPage,
  DashboardHealthCheckPage,
  DashboardHealthDetailPage,
  DashboardSmartWatchPage,
  DashboardSmartWatchGraphPage,
  ThrivingAIAnalyticsPage,
  CalendarPage,
  CalendarCreatePage,
  CalendarEditPage,
  CalendarEventsPage,
  RecordsPage,
  IoTPage,
  IoTLinkPage,
  IoTEditPage,
  IoTLocationsPage,
  ReportsPage,
  VersionControlPage,
  CustomerJourneyPage,
  GuidesPage,
  CarePlanPage,
  DashboardActivityLogPage,
  DashboardDailyAnalyticsPage,
  DashboardSensorActivityInsightsPage,
  DashboardActivityLogDetailsPage,
  ChatnelsMoodPage,
  ChatnelsDetailPage,
  DashboardSummary,
  ZinniaPage,
  CreateZinniaPage,
  EditZinniaPage,
  DashboardStressIndexPage,
  DashboardStressUserScorePage,
  SupportListingPage,
  CareFacilityPage,
  CreateCareFacilityPage,
  CareFacilityDetailPage,
  SocialCircleEventsPage,
  SocialCircleEventsDetailPage,
  CreateSocialCircleEventsPage,
  WellbeingSurveyPage,
  LonelinessSurveyPage,
  PHQ9SurveyPage,
  GAD7SurveyPage,
  EQ5SurveyPage,
  SurveyUserDetailPage,
  SensorPage,
  CreateCareCircleChatPage,
  CreateCargiverChatPage,
  CreateCarehomeChatPage,
  SocialCircleFlagPage,
  CareHomePermissions,
  DashboardBrainBoostPage,
  DashboardGameUserDetailsPage,
  CaregiversV2Page,
  CareHomesV2Page,
  AssignCareHomesPage,
  MyCareHomesPage,
  GlobalEventsPage,
  CreateGlobalEventPage,
  EditGlobalEventPage,
  GlobalEventDetailPage,
  DashboardRoomOccupancyPage
};
